import { fromJS, List, Record } from 'immutable'
import { BrokeragePipelineCriticalDates } from './BrokeragePipelineCriticalDates'

export interface IConfiguration {
  readonly addressTypes: List<string>
  readonly apiKeyTypes: List<string>
  readonly areaUnits: List<string>
  readonly assignmentDueAdvancedOptions: List<string>
  readonly assignmentLabels: List<string>
  readonly assignmentPriorities: List<string>
  readonly assignmentSortOptions: List<string>
  readonly assignmentStatuses: List<string>
  readonly brokeragePipelineCriticalDates: List<BrokeragePipelineCriticalDates>
  readonly brokeragePipelineSortOptions: List<string>
  readonly buildingClasses: List<string>
  readonly connectionTypes: List<string>
  readonly contactSortOptions: List<string>
  readonly corridors: List<string>
  readonly dateRange: List<string>
  readonly developmentSiteSortOptions: List<string>
  readonly developmentSiteStatuses: List<string>
  readonly dueDiligenceItemResponsibilities: List<string>
  readonly dueDiligenceItemTypes: List<string>
  readonly emailTypes: List<string>
  readonly entityAccessOptions: List<string>
  readonly fileTags: List<string>
  readonly goalSortOptions: List<string>
  readonly goalTypeOptions: List<string>
  readonly landingPageOptions: List<string>
  readonly leadPriorityOptions: List<string>
  readonly leadSortOptions: List<string>
  readonly leaseTypes: List<string>
  readonly listingSortOptions: List<string>
  readonly listingStatuses: List<string>
  readonly listingTypes: List<string>
  readonly phoneTypes: List<string>
  readonly pipelineStatuses: List<string>
  readonly priceUnits: List<string>
  readonly propertySortOptions: List<string>
  readonly propertyStatuses: List<string>
  readonly propertyTypes: List<string>
  readonly reminderPeriods: List<string>
  readonly rentalRateUnits: List<string>
  readonly signSortOptions: List<string>
  readonly soldPropertiesSortOptions: List<string>
  readonly teamSortOptions: List<string>
  readonly userSortOptions: List<string>
}

const ConfigurationRecord = Record({
  addressTypes: List<string>(),
  apiKeyTypes: List<string>(),
  areaUnits: List<string>(),
  assignmentDueAdvancedOptions: List<string>(),
  assignmentLabels: List<string>(),
  assignmentPriorities: List<string>(),
  assignmentSortOptions: List<string>(),
  assignmentStatuses: List<string>(),
  brokeragePipelineCriticalDates: List<BrokeragePipelineCriticalDates>(),
  brokeragePipelineSortOptions: List<string>(),
  buildingClasses: List<string>(),
  connectionTypes: List<string>(),
  contactSortOptions: List<string>(),
  corridors: List<string>(),
  dateRange: List<string>(),
  developmentSiteSortOptions: List<string>(),
  developmentSiteStatuses: List<string>(),
  dueDiligenceItemResponsibilities: List<string>(),
  dueDiligenceItemTypes: List<string>(),
  emailTypes: List<string>(),
  entityAccessOptions: List<string>(),
  fileTags: List<string>(),
  goalSortOptions: List<string>(),
  goalTypeOptions: List<string>(),
  landingPageOptions: List<string>(),
  leadPriorityOptions: List<string>(),
  leadSortOptions: List<string>(),
  leaseTypes: List<string>(),
  listingSortOptions: List<string>(),
  listingStatuses: List<string>(),
  listingTypes: List<string>(),
  phoneTypes: List<string>(),
  pipelineStatuses: List<string>(),
  priceUnits: List<string>(),
  propertySortOptions: List<string>(),
  propertyStatuses: List<string>(),
  propertyTypes: List<string>(),
  reminderPeriods: List<string>(),
  rentalRateUnits: List<string>(),
  signSortOptions: List<string>(),
  soldPropertiesSortOptions: List<string>(),
  teamSortOptions: List<string>(),
  userSortOptions: List<string>(),
})

export class Configuration extends ConfigurationRecord
  implements IConfiguration {
  public static fromJS(props?: Partial<IConfiguration>) {
    return new Configuration(fromJS(props))
  }

  public readonly addressTypes: List<string>
  public readonly apiKeyTypes: List<string>
  public readonly areaUnits: List<string>
  public readonly assignmentDueAdvancedOptions: List<string>
  public readonly assignmentLabels: List<string>
  public readonly assignmentPriorities: List<string>
  public readonly assignmentSortOptions: List<string>
  public readonly assignmentStatuses: List<string>
  public readonly brokeragePipelineCriticalDates: List<
    BrokeragePipelineCriticalDates
  >
  public readonly brokeragePipelineSortOptions: List<string>
  public readonly buildingClasses: List<string>
  public readonly connectionTypes: List<string>
  public readonly contactSortOptions: List<string>
  public readonly corridors: List<string>
  public readonly dateRange: List<string>
  public readonly developmentSiteSortOptions: List<string>
  public readonly developmentSiteStatuses: List<string>
  public readonly dueDiligenceItemResponsibilities: List<string>
  public readonly dueDiligenceItemTypes: List<string>
  public readonly emailTypes: List<string>
  public readonly entityAccessOptions: List<string>
  public readonly fileTags: List<string>
  public readonly goalSortOptions: List<string>
  public readonly goalTypeOptions: List<string>
  public readonly landingPageOptions: List<string>
  public readonly leadPriorityOptions: List<string>
  public readonly leadSortOptions: List<string>
  public readonly leaseTypes: List<string>
  public readonly listingSortOptions: List<string>
  public readonly listingStatuses: List<string>
  public readonly listingTypes: List<string>
  public readonly phoneTypes: List<string>
  public readonly pipelineStatuses: List<string>
  public readonly priceUnits: List<string>
  public readonly propertySortOptions: List<string>
  public readonly propertyStatuses: List<string>
  public readonly propertyTypes: List<string>
  public readonly reminderPeriods: List<string>
  public readonly rentalRateUnits: List<string>
  public readonly signSortOptions: List<string>
  public readonly soldPropertiesSortOptions: List<string>
  public readonly teamSortOptions: List<string>
  public readonly userSortOptions: List<string>

  constructor(props?: Partial<Configuration>) {
    props ? super(props) : super()
  }
}
